import React from 'react';

const NotFound = () => {
  return (
    <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - 110px)' }}>
        <div className="w-full max-w-xl mx-auto p-4 text-center">
            <h1 className="text-4xl font-bold mb-4">404</h1>
            <p className="text-lg text-gray-500">Página não encontrada</p>
        </div>
    </div>
  );
};

export default NotFound;
